<template>
  <div class="jumbotron no_space dmbs-container">
    <h1>{{$t('Mis Operaciones')}}</h1>
    <div
      id="fuera"
      class="container fluid mt-0"
      style="height: 100%; display: block;"
    >
      <iframe
        :src="iframeSrc"
        style="min-width: 100%; border: none;"
        frameborder="no"
        width="100%"
        scrolling="no"
        id="iFrameResizer0"
        @load="resizeIframe"
      >Su navegador no soporta IFRAMES. Inténtelo con otro distinto.</iframe>
    </div>
  </div>
</template>
<style>
iframe {
  width: 1px;
  min-width: 100%;
}
</style>
<script>
import { globales } from "../components/comunes";
import iFrameResize from "../assets/iframeResizer";

export default {
  mixins: [globales],
  computed: {
    iframeSrc() {
      const urlBase =
        "https://iframekb.janto.es/public/janto/main.php?Nivel=MisOperaciones";
      const Idioma = "&Idioma=" + this.$i18n.locale.toUpperCase();

      return urlBase + Idioma;
    },
  },
  methods: {
    resizeIframe(event) {
      const iframeActual = document.getElementById("fuera");
      // $('iframe').iFrameResize( [{log: true}] );
      var iframes = iFrameResize(
        {
          log: false, // Enable console logging
          heightCalculationMethod: "lowestElement",
        },
        "#" + event.target.id
      );
    },
  },
};
</script>
